import { useState, useEffect } from "react";
import axios from "axios";

// Imports de Navbar y contexto si los tienes
import { NavBarAdm } from "../Components/NavBarAdm";

//Import Hooks
import { useDataContext } from "../Context/dataContext";
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useCurrencyPrice } from "../Hooks/useCurrencyPrice";
import { usePorcentPrice } from "../Hooks/usePorcentPrice";
import { useBonusPrice } from "../Hooks/useBonusPrice";

import spainFlag from "../Assets/Images/spain.png";
import usaFlag from "../Assets/Images/usa.png";
import ukFlag from "../Assets/Images/uk.png";
import venezuelaFlag from "../Assets/Images/venezuela.png";

function CurrencyUpdate() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const { data } = useCurrencyPrice();
  const { porcents } = usePorcentPrice(accessToken.access_token);
  const { aux } = useBonusPrice(accessToken.access_token);

  // const [currencyPrice, setCurrencyPrice] = useState([]);
  // const [porcentPrice, setPorcentPrice] = useState([]);
  // const [porcent, setPorcent] = useState([]);

  // State management
  const [activeMainTab, setActiveMainTab] = useState("Tasas");
  const [activeTab, setActiveTab] = useState("EUR");

  // Modal and form states
  const [showModal, setShowModal] = useState(false);

  // Form data states
  const [location, setLocation] = useState("Obligatorio");
  const [additionalInfo, setAdditionalInfo] = useState("");

  // Porcent form states
  const [porcentId, setPorcentId] = useState(null);
  const [selectedPorcent, setSelectedPorcent] = useState(null);

  const [formDataPorcent, setFormDataPorcent] = useState({
    por_porcentGbp: "",
    por_porcentEur: "",
    por_porcentUsd: "",
    por_deliveryPrice: "",
  });

  const [formData, setFormData] = useState({
    cur_EurToBs: "",
    cur_EurToUsd: "",
    cur_EurToGbp: "",
    cur_EurToUsd_Pa: "",
    cur_EurToUsd_Ecu: "",
    cur_EurToSol_Pe: "",
    cur_EurToPes_Ch: "",
    cur_EurToPes_Mex: "",
    cur_EurToCol_Pes: "",
    cur_EurToArg_Pes: "",
    cur_EurToBra_Rea: "",
    cur_EurToUru_Pes: "",
    cur_EurToPar_Gua: "",
    cur_EurToBol_Bol: "",
    cur_EurToDop: "",
    cur_UsdToBs: "",
    cur_UsdToEur: "",
    cur_UsdToGbp: "",
    cur_UsdToUsd_Pa: "",
    cur_UsdToUsd_Ecu: "",
    cur_UsdToSol_Pe: "",
    cur_UsdToPes_Ch: "",
    cur_UsdToPes_Mex: "",
    cur_UsdToCol_Pes: "",
    cur_UsdToArg_Pes: "",
    cur_UsdToBra_Rea: "",
    cur_UsdToUru_Pes: "",
    cur_UsdToPar_Gua: "",
    cur_UsdToBol_Bol: "",
    cur_UsdToDop: "",
    cur_GbpToBs: "",
    cur_GbpToUsd: "",
    cur_GbpToEur: "",
    cur_GbpToUsd_Pa: "",
    cur_GbpToUsd_Ecu: "",
    cur_GbpToSol_Pe: "",
    cur_GbpToPes_Ch: "",
    cur_GbpToPes_Mex: "",
    cur_GbpToCol_Pes: "",
    cur_GbpToArg_Pes: "",
    cur_GbpToBra_Rea: "",
    cur_GbpToUru_Pes: "",
    cur_GbpToPar_Gua: "",
    cur_GbpToBol_Bol: "",
    cur_GbpToDop: "",
    cur_UsdTtoBs: "",
    cur_UsdTtoUsd: "",
  });

  const [formDataBonus, setFormDataBonus] = useState({
    aux_loyalPointAmount: "",
    aux_loyalPointValue: "",
    aux_minimumLoyalPointsToRedeem: "",
    aux_referralBonusValue: "",
  });

  const handleEdit = async (event) => {
    event.preventDefault();

    try {
      await axios.put(`${url}/CurrencyPrice/1`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      closeModal();
    } catch (error) {
      console.log(error);
    } finally {
      window.location.reload();
    }
  };

  const handleEditBonus = async (event) => {
    event.preventDefault();

    try {
      await axios.put(`${url}/AuxVariables/update`, formDataBonus, {
        headers: {
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      window.location.reload();
    }
  };

  const handleFetchingPorcent = async (id) => {
    try {
      if (id) {
        setPorcentId(id);

        const response = await axios.get(`${url}/PorcentPrice/${id}`, {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        });
        setSelectedPorcent(response.data);

        setFormDataPorcent({
          por_porcentGbp: response.data.por_porcentGbp,
          por_porcentEur: response.data.por_porcentEur,
          por_porcentUsd: response.data.por_porcentUsd,
          por_deliveryPrice: response.data.por_deliveryPrice,
          por_status: response.data.por_status,
          por_comment: response.data.por_comment,
        });

        setLocation(response.data.por_status);
        setAdditionalInfo(response.data.por_comment);
      } else {
        setFormDataPorcent({
          por_porcentGbp: "",
          por_porcentEur: "",
          por_porcentUsd: "",
          por_deliveryPrice: "",
          por_status: "",
          por_comment: "",
        });

        setLocation("");
        setAdditionalInfo("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdatePorcentaje = async () => {
    try {
      const requestData = {
        por_porcentGbp: formDataPorcent.por_porcentGbp,
        por_porcentEur: formDataPorcent.por_porcentEur,
        por_porcentUsd: formDataPorcent.por_porcentUsd,
        por_deliveryPrice: formDataPorcent.por_deliveryPrice,
        por_status: location,
        por_comment: additionalInfo,
      };

      const id = porcentId;

      await axios.put(`${url}/PorcentPrice/${id}`, requestData, {
        headers: {
          Authorization: `Bearer ${accessToken.access_token}`,
        },
      });

      handleFetchingPorcent();
    } catch (error) {
      console.error("Error al actualizar los datos de porcentaje:", error);
    }
  };

  const handleInputChangePorcent = (e) => {
    setFormDataPorcent({
      ...formDataPorcent,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChangeBonus = (e) => {
    setFormDataBonus({
      ...formDataBonus,
      [e.target.name]: e.target.value,
    });
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [currencyRes, porcentRes, auxRes] = await Promise.all([
          axios.get(`${url}/CurrencyPrice`, {
            headers: { Authorization: `Bearer ${accessToken.access_token}` },
          }),
          axios.get(`${url}/PorcentPrice`, {
            headers: { Authorization: `Bearer ${accessToken.access_token}` },
          }),
          axios.get(`${url}/AuxVariables`, {
            headers: { Authorization: `Bearer ${accessToken.access_token}` },
          }),
        ]);
        setFormData(currencyRes.data[0]);
        setFormDataPorcent(porcentRes.data[0]);
        setFormDataBonus(auxRes.data[0]);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllData();
  }, [url, accessToken]);

  return (
    <div className="currency-page">
      <div className="currency-wrapper">
        <h2 className="currency-title">Configuración de Tasas </h2>

        <div className="currency-tabs">
          <button
            className={activeMainTab === "Tasas" ? "active" : ""}
            onClick={() => setActiveMainTab("Tasas")}
          >
            Tasas
          </button>
          <button
            className={activeMainTab === "Efectivo" ? "active" : ""}
            onClick={() => setActiveMainTab("Efectivo")}
          >
            Entrega en Efectivo
          </button>
          <button
            className={activeMainTab === "Bonus" ? "active" : ""}
            onClick={() => setActiveMainTab("Bonus")}
          >
            Bonus
          </button>
        </div>

        {activeMainTab === "Tasas" && (
          <div className="main-tasas">
            <div className="rates-grid">
              <label>
                <img src={spainFlag} alt="eur" />
                EUR a Bs:
                <input
                  type="number"
                  name="cur_EurToBs"
                  defaultValue={data.cur_EurToBs || ""}
                  onChange={handleInputChange}
                />
                <img src={venezuelaFlag} alt="bs" />
              </label>
              <label>
                <img src={spainFlag} alt="eur" />
                EUR a USD:
                <input
                  type="number"
                  name="cur_EurToUsd"
                  defaultValue={data.cur_EurToUsd || ""}
                  onChange={handleInputChange}
                />
                <img src={usaFlag} alt="usd" />
              </label>
              <label>
                <img src={usaFlag} alt="usd" />
                USD a Bs:
                <input
                  type="number"
                  name="cur_UsdToBs"
                  defaultValue={data.cur_UsdToBs || ""}
                  onChange={handleInputChange}
                />
                <img src={venezuelaFlag} alt="bs" />
              </label>
              <label>
                <img src={ukFlag} alt="gbp" />
                GBP a USD:
                <input
                  type="number"
                  name="cur_GbpToUsd"
                  defaultValue={data.cur_GbpToUsd || ""}
                  onChange={handleInputChange}
                />
                <img src={usaFlag} alt="usd" />
              </label>
              <label>
                <img src={ukFlag} alt="gbp" />
                GBP a Bs:
                <input
                  type="number"
                  name="cur_GbpToBs"
                  defaultValue={data.cur_GbpToBs || ""}
                  onChange={handleInputChange}
                />
                <img src={venezuelaFlag} alt="bs" />
              </label>
            </div>

            <div className="currency-actions">
              <button className="btn-secondary" onClick={openModal}>
                Editar tasas secundarias
              </button>
              <button className="btn-primary" onClick={handleEdit}>
                Guardar cambios
              </button>
            </div>
          </div>
        )}

        {activeMainTab === "Efectivo" && (
          <div className="efectivo-section">
            <h3>Ubicación:</h3>
            <select
              className="custom-select"
              onChange={(e) => handleFetchingPorcent(e.target.value)}
            >
              <option value="">Selecciona ubicación</option>
              {porcents.map((p) => (
                <option key={p.por_id} value={p.por_id}>
                  {p.por_stateLocation}
                </option>
              ))}
            </select>

            {selectedPorcent && (
              <div className="porcent-form">
                <label>Porcentaje GBP:</label>
                <input
                  type="number"
                  name="por_porcentGbp"
                  defaultValue={formDataPorcent.por_porcentGbp || ""}
                  onChange={handleInputChangePorcent}
                />
                <label>Porcentaje USD:</label>
                <input
                  type="number"
                  name="por_porcentUsd"
                  defaultValue={formDataPorcent.por_porcentUsd || ""}
                  onChange={handleInputChangePorcent}
                />
                <label>Porcentaje EUR:</label>
                <input
                  type="number"
                  name="por_porcentEur"
                  defaultValue={formDataPorcent.por_porcentEur || ""}
                  onChange={handleInputChangePorcent}
                />

                {location === "Obligatorio" && (
                  <>
                    <label>Precio de Entrega:</label>
                    <input
                      type="number"
                      name="por_deliveryPrice"
                      value={formDataPorcent.por_deliveryPrice || ""}
                      onChange={handleInputChangePorcent}
                    />
                  </>
                )}

                <div className="estado-buttons">
                  {[
                    "Obligatorio",
                    "No obligatorio",
                    "Oficina",
                    "Desactivado",
                  ].map((opt) => (
                    <button
                      key={opt}
                      className={location === opt ? "active" : ""}
                      onClick={() => setLocation(opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>

                {(location === "Oficina" || location === "No obligatorio") && (
                  <textarea
                    value={additionalInfo}
                    onChange={(e) => setAdditionalInfo(e.target.value)}
                    placeholder="Comentario..."
                  />
                )}

                <button
                  className="btn-primary"
                  onClick={handleUpdatePorcentaje}
                >
                  Guardar Configuración
                </button>
              </div>
            )}
          </div>
        )}

        {activeMainTab === "Bonus" && (
          <div className="main-tasas">
            <div className="rates-grid">
              <label>
                Punto por transacción:
                <input
                  type="number"
                  name="aux_loyalPointAmount"
                  defaultValue={aux.aux_loyalPointAmount || ""}
                  onChange={handleInputChangeBonus}
                />
              </label>
              <label>
                Valor por punto:
                <input
                  type="number"
                  name="aux_loyalPointValue"
                  defaultValue={aux.aux_loyalPointValue || ""}
                  onChange={handleInputChangeBonus}
                />
              </label>
              <label>
                Minimo de puntos para canje:
                <input
                  type="number"
                  name="aux_minimumLoyalPointsToRedeem"
                  defaultValue={aux.aux_minimumLoyalPointsToRedeem || ""}
                  onChange={handleInputChangeBonus}
                />
              </label>
              <label>
                Bonus por primera transaccion:
                <input
                  type="number"
                  name="aux_referralBonusValue"
                  defaultValue={aux.aux_referralBonusValue || ""}
                  onChange={handleInputChangeBonus}
                />
              </label>
            </div>

            <div className="currency-actions">
              <button className="btn-primary" onClick={handleEditBonus}>
                Guardar cambios
              </button>
            </div>
          </div>
        )}

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content currency-modal">
              <h3>Tasas Secundarias</h3>
              <div className="tabs">
                {["EUR", "USD", "GBP", "USDT"].map((tab) => (
                  <button
                    key={tab}
                    className={activeTab === tab ? "active" : ""}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="modal-scroll">
                {activeTab === "EUR" && (
                  <>
                    <label>EUR a USD (Panamá):</label>
                    <input
                      type="number"
                      name="cur_EurToUsd_Pa"
                      defaultValue={data.cur_EurToUsd_Pa || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a USD (Ecuador):</label>
                    <input
                      type="number"
                      name="cur_EurToUsd_Ecu"
                      defaultValue={data.cur_EurToUsd_Ecu || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a Sol Peruano:</label>
                    <input
                      type="number"
                      name="cur_EurToSol_Pe"
                      defaultValue={data.cur_EurToSol_Pe || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a Peso Chileno:</label>
                    <input
                      type="number"
                      name="cur_EurToPes_Ch"
                      defaultValue={data.cur_EurToPes_Ch || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a Peso Mexicano:</label>
                    <input
                      type="number"
                      name="cur_EurToPes_Mex"
                      defaultValue={data.cur_EurToPes_Mex || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a Peso Colombiano:</label>
                    <input
                      type="number"
                      name="cur_EurToCol_Pes"
                      defaultValue={data.cur_EurToCol_Pes || ""}
                      onChange={handleInputChange}
                    />

                    <label>EUR a Peso Argentino:</label>
                    <input
                      type="number"
                      name="cur_EurToArg_Pes"
                      defaultValue={data.cur_EurToArg_Pes || ""}
                      onChange={handleInputChange}
                    />
                  </>
                )}

                {activeTab === "USD" && (
                  <>
                    <label>USD a Sol Peruano:</label>
                    <input
                      type="number"
                      name="cur_UsdToSol_Pe"
                      defaultValue={data.cur_UsdToSol_Pe || ""}
                      onChange={handleInputChange}
                    />

                    <label>USD a Peso Chileno:</label>
                    <input
                      type="number"
                      name="cur_UsdToPes_Ch"
                      defaultValue={data.cur_UsdToPes_Ch || ""}
                      onChange={handleInputChange}
                    />

                    <label>USD a Peso Mexicano:</label>
                    <input
                      type="number"
                      name="cur_UsdToPes_Mex"
                      defaultValue={data.cur_UsdToPes_Mex || ""}
                      onChange={handleInputChange}
                    />

                    <label>USD a Peso Colombiano:</label>
                    <input
                      type="number"
                      name="cur_UsdToCol_Pes"
                      defaultValue={data.cur_UsdToCol_Pes || ""}
                      onChange={handleInputChange}
                    />

                    <label>USD a Peso Argentino:</label>
                    <input
                      type="number"
                      name="cur_UsdToArg_Pes"
                      defaultValue={data.cur_UsdToArg_Pes || ""}
                      onChange={handleInputChange}
                    />

                    <label>USD a Euro:</label>
                    <input
                      type="number"
                      name="cur_UsdToEur"
                      defaultValue={data.cur_UsdToEur || ""}
                      onChange={handleInputChange}
                    />
                  </>
                )}

                {activeTab === "GBP" && (
                  <>
                    <label>GBP a Sol Peruano:</label>
                    <input
                      type="number"
                      name="cur_GbpToSol_Pe"
                      defaultValue={data.cur_GbpToSol_Pe || ""}
                      onChange={handleInputChange}
                    />

                    <label>GBP a Peso Chileno:</label>
                    <input
                      type="number"
                      name="cur_GbpToPes_Ch"
                      defaultValue={data.cur_GbpToPes_Ch || ""}
                      onChange={handleInputChange}
                    />

                    <label>GBP a Peso Mexicano:</label>
                    <input
                      type="number"
                      name="cur_GbpToPes_Mex"
                      defaultValue={data.cur_GbpToPes_Mex || ""}
                      onChange={handleInputChange}
                    />

                    <label>GBP a Peso Colombiano:</label>
                    <input
                      type="number"
                      name="cur_GbpToCol_Pes"
                      defaultValue={data.cur_GbpToCol_Pes || ""}
                      onChange={handleInputChange}
                    />

                    <label>GBP a Peso Argentino:</label>
                    <input
                      type="number"
                      name="cur_GbpToArg_Pes"
                      defaultValue={data.cur_GbpToArg_Pes || ""}
                      onChange={handleInputChange}
                    />
                  </>
                )}

                {activeTab === "USDT" && (
                  <>
                    <label>USDT a Bs:</label>
                    <input
                      type="number"
                      name="cur_UsdtToBs"
                      defaultValue={data.cur_UsdtToBs || ""}
                      onChange={handleInputChange}
                    />

                    <label>USDT a USD:</label>
                    <input
                      type="number"
                      name="cur_UsdtToUsd"
                      defaultValue={data.cur_UsdtToUsd || ""}
                      onChange={handleInputChange}
                    />
                  </>
                )}
              </div>

              <div className="currency-actions">
                <button className="btn-primary" onClick={handleEdit}>
                  Guardar Cambios
                </button>
                <button className="btn-primary" onClick={closeModal}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <NavBarAdm />
    </div>
  );
}

export { CurrencyUpdate };
